import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import img1 from '../images/early.jpeg'
import imgbird from '../images/bird.jpeg'
// import img1 from '../images/image1.jpg'
import boldizar1 from '../images/boldizar.jpg'
import boldizar2 from '../images/boldizar2.jpg'
import crane1 from '../images/girage9.jpg'
import crane2 from '../images/crane2.jpg'
import girage1 from '../images/girageshop.jpg'
import girage2 from '../images/trailer3.jpg'

// import img9 from '../images/image9.jpg'
// import "./styles.css";

// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
// import "swiper/swiper.min.css";
const Homeslider = () => {
  // install Swiper modules
  SwiperCore.use([Autoplay, Pagination, Navigation]);
  return (
    <div >
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        className='mySwiper'
      >
        <SwiperSlide>
          <img src={imgbird} alt='' className='img1-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={boldizar1} alt='' className='img1-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={boldizar2} alt='' className='img1-fluid' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={crane1} alt='' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={crane2} alt='' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={girage1} alt='' />
        </SwiperSlide>
        <SwiperSlide>
          <img src={girage2} alt='' />
        </SwiperSlide>

      </Swiper>

    </div>
  )
}

export default Homeslider